const mPulse = {
	pageGroup: ((navigation) =>
		navigation.Action === 'Index'
			? navigation.Controller
			: `${navigation.Controller}-${navigation.Action}`)(yTos.navigation),

	referrerType: ((document) => {
		const storeHost = document.location.host
		if (!document.referrer) {
			return 'Direct'
		}
		const referrerHost = document.referrer.replace(/.*\/\/([^/]+).*/, '$1')
		const isReferrerExternal = referrerHost.indexOf(storeHost) < 0
		return isReferrerExternal ? 'External' : 'Internal'
	})(document),

	abTest: yTos.navigation.AbTests.join('|'),

	deviceMemory: (navigator.deviceMemory || -1).toFixed(),
}

export default mPulse
